<template>
  <div class="ttb">
    <template
      v-for="node in nodes"
      :key="node.id"
    >
      <div
        v-if="hasChildren(node)"
        class="ttb-unit"
      >
        <component
          :is="canPickUnit(node) ? tag : 'p'"
          :type="canPickUnit(node) && tag === 'button' ? 'button' : null"
          class="ttb-row ttb-unit-head"
          :class="{
            'is-selected': canPickUnit(node) && isChosen(node.id),
            'is-static': !canPickUnit(node)
          }"
          @click="canPickUnit(node) && onClick(node.id)"
        >
          <input
            v-if="canPickUnit(node) && tag === 'label'"
            type="checkbox"
            class="ttb-native"
            :checked="isChosen(node.id) || isCovered(node.id)"
            :disabled="isCovered(node.id)"
            @change="$emit('pick', node.id, $event.target.checked)"
          >
          <slot
            v-if="canPickUnit(node)"
            name="before"
            :node="node"
          />
          <span class="ttb-unit-mark" />
          <span class="ttb-name">{{ node.name }}</span>
          <slot
            v-if="canPickUnit(node)"
            name="after"
            :node="node"
          />
        </component>

        <div class="ttb-children">
          <team-tree-branch
            :nodes="node.children"
            :tag="tag"
            :is-chosen="isChosen"
            :is-covered="isCovered"
            :is-selectable="isSelectable"
            :units-selectable="unitsSelectable"
            @pick="(id, checked) => $emit('pick', id, checked)"
          >
            <template #before="slotProps">
              <slot
                name="before"
                v-bind="slotProps"
              />
            </template>
            <template #after="slotProps">
              <slot
                name="after"
                v-bind="slotProps"
              />
            </template>
          </team-tree-branch>
        </div>
      </div>

      <component
        :is="tag"
        v-else
        :type="tag === 'button' ? 'button' : null"
        class="ttb-row ttb-team"
        :class="{ 'is-selected': isChosen(node.id) }"
        @click="onClick(node.id)"
      >
        <input
          v-if="tag === 'label'"
          type="checkbox"
          class="ttb-native"
          :checked="isChosen(node.id) || isCovered(node.id)"
          :disabled="isCovered(node.id)"
          @change="$emit('pick', node.id, $event.target.checked)"
        >
        <slot
          name="before"
          :node="node"
        />
        <span class="ttb-name">{{ node.name }}</span>
        <slot
          name="after"
          :node="node"
        />
      </component>
    </template>
  </div>
</template>

<script>
export default {
  name: "TeamTreeBranch",
  props: {
    nodes: { type: Array, default: () => [] },
    tag: { type: String, default: "button" },
    isChosen: { type: Function, required: true },
    // Nó alcançado por uma selecao acima dele: aparece marcado, sem permitir
    // desmarcar, porque quem manda e o ancestral.
    isCovered: { type: Function, default: () => false },
    isSelectable: { type: Function, default: () => true },
    unitsSelectable: { type: Boolean, default: true }
  },
  emits: ["pick"],
  methods: {
    hasChildren(node) {
      return !!(node.children && node.children.length);
    },
    canPickUnit(node) {
      return this.unitsSelectable && this.isSelectable(node.id);
    },
    onClick(id) {
      if (this.tag === "button" && !this.isCovered(id)) this.$emit("pick", id);
    }
  }
};
</script>

<style scoped>
.ttb-row {
  position: relative;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  background: transparent;
  border: none;
  text-align: left;
  padding: 8px 12px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #3a3a3a;
  font-family: inherit;
  box-sizing: border-box;
}
.ttb-row:hover {
  background: #faf9fd;
}
.ttb-row.is-selected {
  background: rgba(79, 63, 130, 0.1);
}
.ttb-row.is-selected .ttb-name {
  color: #4f3f82;
  font-weight: 600;
}
.ttb-unit-head {
  padding: 7px 12px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #8a83a0;
}
.ttb-unit-head.is-static {
  cursor: default;
  margin: 0;
}
.ttb-unit-head.is-static:hover {
  background: transparent;
}
.ttb-unit + .ttb-unit,
.ttb-team + .ttb-unit {
  margin-top: 4px;
}
.ttb-unit-mark {
  width: 7px;
  height: 7px;
  border-radius: 2px;
  background: #4f3f82;
  opacity: 0.55;
  flex: none;
}
.ttb-children {
  margin-left: 22px;
}
.ttb-native:disabled {
  cursor: default;
}
.ttb-native {
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;
}
.ttb-name {
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
